import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationContextService, ILookUpType, IProducPosttDtoModel, IProductCountryDtoModel, IProductResolvedData, IProductTypeModel, ITaxonomyDtoModel, ITaxonomyDtoModels, OptionService, PrefixService, ProductService, RolePermissionService, UtilitiesService } from 'lib-core-shared';
import { ProductDetailsViewModel } from './model/product-details-viewmodel';
import { PageBaseDirective } from 'lib-ui-shared';
import { ProductRouteMap, productRouteMap } from '../../app-routing.module';

@Component({
  selector: 'app-product-create',
  templateUrl: './product-create-page.component.html',
  styleUrls: ['./product-create-page.component.scss']
})
export class ProductCreatePageComponent  extends PageBaseDirective<IProducPosttDtoModel> implements OnInit {
  public productDetailChildren: ProductRouteMap[] | undefined;
  public code: string | undefined;
  public productName: string | undefined;
  public showCompanyPanel: boolean = true;

  // public section: ProductSectionsEnum = ProductSectionsEnum.core;
  public productChildren: ProductRouteMap[] | undefined;
  public formGroup: FormGroup;
  shippingMethods: any;
  lookupData!: IProductResolvedData;
  countriesWithPostCode: string[] = [];
  public countries!: ILookUpType[];
  public productDetailsViewModel: ProductDetailsViewModel;
  public masterProductSatuses!: ILookUpType[];
  public componentStatuses!: ILookUpType[];
  public taxRateCategories!: ILookUpType[];
  public discountCategories!: ILookUpType[];
  public productTypes!: IProductTypeModel[];
  public taxonomies!: ITaxonomyDtoModel[];

  constructor( public formBuilder: FormBuilder, 
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public modalService: NgbModal,
    public roleService: RolePermissionService,
    public productService: ProductService,
    public utilitiesService: UtilitiesService,
    public applicationContext: ApplicationContextService,
    public optionService: OptionService,
    private prefixService: PrefixService
  ) {
      super(activatedRoute, router, modalService, utilitiesService, roleService, applicationContext);
      // this.countryCode = `${environment?.branch?.address?.countryCode}`;

      if (productRouteMap?.children) {
        const productResult = productRouteMap.children.filter(x => x.name === 'details');   
        this.productDetailChildren = productResult?.length ? productResult[0].children: [];
      }
      this.productChildren = productRouteMap.children ? productRouteMap.children[2].children : [];
      this.productDetailsViewModel = new ProductDetailsViewModel(formBuilder, this.prefixService);
      this.formGroup = this.productDetailsViewModel.form();
      // this.setAddress();
      this.activatedRoute.data.subscribe((payload) => {
        this.lookupData = payload.productData as IProductResolvedData;
        this.componentStatuses = this.lookupData.componentStatuses;
        this.discountCategories = this.lookupData.discountCategories;
        this.masterProductSatuses = this.lookupData.masterProductSatuses;
        this.taxRateCategories = this.lookupData.taxRateCategories;
        this.productTypes = this.lookupData.productTypes;
        this.countries = this.lookupData.countries.filter((country: ILookUpType) => country.name && country.code).sort((a: ILookUpType,b:ILookUpType)=> {
          if(a.name && b.name){
            if(a.name>b.name){
              return 1
            } else if(a.name<b.name){
              return -1
            }
            else {
              return 0
            }
          } else{
            return 0
          }
        });
      });
      if (productRouteMap?.children) {
        const productResult = productRouteMap.children.filter(x => x.name === 'details');   
        this.productDetailChildren = productResult?.length ? productResult[0].children: [];
      }
      this.productChildren = productRouteMap.children ? productRouteMap.children[2].children : [];
      this.savedSuccessfullyMessage = 'Product saved successfully.';
      this.permission = 'ProductManagement.Product.Create'
  }

  public addressForm(): FormGroup {
    return this.formGroup.controls.address as FormGroup;
  }

  ngOnInit(): void {  
    this.optionService.getTaxonomies('A').subscribe((response: ITaxonomyDtoModels) => {
      this.taxonomies = response.taxonomies;
    })
    this.closeEmitter.subscribe(x =>  this.router.navigate([`../details/${this.newId?.id}`], { relativeTo: this.activatedRoute, queryParams: this.queryParam }))
    const model = {} as IProducPosttDtoModel;
    this.productDetailsViewModel.productDetailFormMapping.toForm(model, this.formGroup);
    // this.formGroup.controls.countryOfOriginCode.setValue(this.countryCode);
    this.formGroup.controls.componentStatus.valueChanges.subscribe(res =>{
      if(res.code === 'Y') {
        this.formGroup.controls.ukCommodityCode.clearValidators()
        this.formGroup.controls.usCommodityCode.clearValidators()
        if(this.formGroup.controls.ukCommodityCode.value === undefined){
          this.formGroup.controls.ukCommodityCode.setValue(null)

        }
        if(this.formGroup.controls.usCommodityCode.value === undefined){
          this.formGroup.controls.usCommodityCode.setValue(null)
        }
       
      } else{
        this.formGroup.controls.ukCommodityCode.setValidators(Validators.required)
        this.formGroup.controls.usCommodityCode.setValidators(Validators.required)
        if(this.formGroup.controls.ukCommodityCode.value === null){
          this.formGroup.controls.ukCommodityCode.setValue(undefined)

        }
        if(this.formGroup.controls.usCommodityCode.value === null){
          this.formGroup.controls.usCommodityCode.setValue(undefined)
        }
      }
    })
    
  }

  public submit() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      const model = this.productDetailsViewModel.productDetailFormMapping.toApplicationModel(this.formGroup);
      if (model) {
        this.save$ = this.productService.save(model);
        this.saveData();
      }
    }
  }

  public reset() {

  }
}
